<template>
  <div>
    <Castle />
    <!-- <Castle v-if="$route.query.category == '라피아캐슬'" /> -->
    <!-- <Maker v-if="$route.query.category == '솔로프리미엄'" /> -->
  </div>
</template>
<script>
import Castle from "./buy/Castle"
// import Maker from "./buy/Maker"

export default {
  components: {
    Castle,
    // Maker,
  },

  created() {
    //const inAppBrowers = ["KAKAO, FB, Instragram, trill"]
    //const isInAppConfig = inAppBrowers.some((e) => navigator.userAgent.indexOf(e) >= 0)
    // if (isInAppConfig) {
    //   alert("인앱 브라우저에서는 로그인등 정상적인 진행이 어려울 수 있습니다.")
    //   return
    // }
    // 비 로그인 시
    // if (!this.$store.state.lafia_user.is_logined) {
    //   // 이벤트가 있다면 저장
    //   if (this.$route.query.event) {
    //     this.$store.commit("ADD_PROMOTION_CODE", this.$route.query.event)
    //   }
    //   alert("예약하기는 로그인 후 이용가능합니다.")
    //   let loginPath = "/auth/login"
    //   if (this.$route.query.event) {
    //     loginPath = loginPath + `?event=${this.$route.query.event}`
    //   }
    //   this.$router.push(loginPath)
    // }
  },
}
</script>
